// extracted by mini-css-extract-plugin
export var container = "styles-module--container--bf207";
export var dark = "styles-module--dark--3891e";
export var slider = "styles-module--slider--c83ec";
export var sliderContainer = "styles-module--sliderContainer--1c12b";